import type { CSSProperties } from "react";

interface IconProps {
  name: string;
  className?: string;
  style?: CSSProperties;
}

/**
 * Thin wrapper around Material Symbols Outlined. The font is loaded via
 * <link rel="stylesheet"> in index.html.
 */
export function Icon({ name, className, style }: IconProps) {
  return (
    <span className={`material-symbols-outlined ${className ?? ""}`} style={style} aria-hidden>
      {name}
    </span>
  );
}
